/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedQuoteProductList } from '../models/PaginatedQuoteProductList';
import type { PatchedQuoteProduct } from '../models/PatchedQuoteProduct';
import type { QuoteProduct } from '../models/QuoteProduct';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class QuotesProductsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedQuoteProductList
     * @throws ApiError
     */
    public quotesProductsList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedQuoteProductList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/quotes-products/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns QuoteProduct
     * @throws ApiError
     */
    public quotesProductsCreate({
        requestBody,
    }: {
        requestBody: QuoteProduct,
    }): CancelablePromise<QuoteProduct> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/quotes-products/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns QuoteProduct
     * @throws ApiError
     */
    public quotesProductsRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this quote product.
         */
        id: number,
    }): CancelablePromise<QuoteProduct> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/quotes-products/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns QuoteProduct
     * @throws ApiError
     */
    public quotesProductsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this quote product.
         */
        id: number,
        requestBody: QuoteProduct,
    }): CancelablePromise<QuoteProduct> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/quotes-products/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns QuoteProduct
     * @throws ApiError
     */
    public quotesProductsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this quote product.
         */
        id: number,
        requestBody?: PatchedQuoteProduct,
    }): CancelablePromise<QuoteProduct> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/quotes-products/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public quotesProductsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this quote product.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/quotes-products/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
